// Rozcestník série Club Opportunities — všechny kluby PL, hotové články prolinkované.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "@phosphor-icons/react";
import AppShell from "../components/AppShell";
import { api } from "../lib/api";

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

function findPost(team, posts) {
    const tn = norm(team);
    return posts.find((p) => {
        const c = norm(p.series_club);
        if (!c) return false;
        return c === tn || c.includes(tn) || tn.includes(c) ||
            tn.split(" ").every((tok) => tok.length > 2 && c.includes(tok));
    });
}

export default function ClubOpportunities() {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/blog/series/club-opportunities").then((r) => setData(r.data)).catch(() => setData({ posts: [], teams: [] }));
    }, []);
    const posts = data?.posts || [];
    const teams = data?.teams || [];

    return (
        <AppShell>
            <div className="space-y-6" data-testid="club-opps-page">
                <header className="border-l-4 border-fa-mint pl-4">
                    <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-fa-mint">
                        <Compass size={14} /> Seriál Fantasy Academy
                    </div>
                    <h1 className="font-display font-black uppercase tracking-tight text-3xl md:text-4xl mt-1">Club Opportunities</h1>
                    <p className="font-mono text-[11px] text-white/55 mt-1 max-w-2xl">
                        Klub po klubu: taktika → FPL příležitosti → rotace → tier list. Postavené na našem scoutingu přípravy a Prediction Modelu.
                    </p>
                </header>

                {!data ? (
                    <p className="font-mono text-[11px] text-white/40">Načítám…</p>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2" data-testid="club-opps-grid">
                        {teams.map((team) => {
                            const post = findPost(team, posts);
                            return post ? (
                                <Link key={team} to={`/academy/${post.slug}`} data-testid={`club-opps-${norm(team).replace(/ /g, "-")}`}
                                      className="border border-fa-mint/40 bg-fa-mint/5 p-3 hover:bg-fa-mint/15 transition-colors group">
                                    <div className="font-display font-black uppercase text-sm">{team}</div>
                                    <p className="font-mono text-[10px] text-white/60 mt-1 line-clamp-2">{post.title}</p>
                                    <div className="font-mono text-[9px] uppercase tracking-widest text-fa-mint mt-2 flex items-center gap-1">
                                        Číst analýzu <ArrowRight size={10} className="group-hover:translate-x-0.5 transition-transform" />
                                    </div>
                                </Link>
                            ) : (
                                <div key={team} data-testid={`club-opps-${norm(team).replace(/ /g, "-")}`}
                                     className="border border-white/10 bg-black/30 p-3 opacity-50">
                                    <div className="font-display font-black uppercase text-sm">{team}</div>
                                    <p className="font-mono text-[9px] uppercase tracking-widest text-white/35 mt-2">Připravujeme</p>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </AppShell>
    );
}
